import { FC } from 'react';
import { State } from 'redux/initialState';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Partner } from 'types';
import { formatCurrencyDecimals } from 'utils/formats';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';

type ContributionOperationDataRowProps = {
  index: number;
  partner: Partner;
};

const ContributionOperationTableRow: FC<ContributionOperationDataRowProps> = ({
  index,
  partner,
}) => {
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );
  const { data } = useOperationDetailsPage();

  const { _id: partnerId, name: partnerName, contributions } = partner;

  const currentContribution = contributions.find(
    (contribution) => contribution.operation === data.operation?._id
  );

  const ndPercentage = currentContribution?.ndPercentage || 0;
  const amount = currentContribution?.amount || 0;

  return (
    <>
      <td
        className="text-left vertical-align-middle pl-2 pl-md-2"
        key={`partner-name-${index}`}
      >
        <Link
          className="text-primary"
          to={`/detalle-socio/${actualSociety?._id}/${partnerId}`}
        >
          {partnerName}
        </Link>
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`partner-nd-${index}`}
      >
        {(ndPercentage || 0).toFixed(2)}%
      </td>

      <td
        className="text-right vertical-align-middle pr-2 pr-md-3"
        key={`partner-percibe-${index}`}
      >
        {formatCurrencyDecimals(amount || 0)}
      </td>
    </>
  );
};
export default ContributionOperationTableRow;
